export const showBadgeOnFavicon = () => {
  const favicon = document.querySelector('.favicon');
  if (favicon) {
    favicon.href = '/fav.ico';
  }
};

export const initFaviconSwitcher = () => {
  const favicon = document.querySelector('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && favicon) {
      favicon.href = '/fav.ico';
    }
  });
};
